import React from 'react'
import { useNavigate } from 'react-router-dom'
import DeckManagement from '../components/DeckManagement'

/**
 * Dedicated page for deck management (create / delete / select).
 * Selecting a deck navigates to the vocabulary page filtered by that deck.
 */
const Decks: React.FC = () => {
  const navigate = useNavigate()

  const handleSelectDeck = (deckId: string) => {
    navigate(`/vocabulary?deck=${deckId}`)
  }

  return <DeckManagement onSelectDeck={handleSelectDeck} />
}

export default Decks
